import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class NewsDeleted extends DomainEvent<DeletedEntity> {}
